import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { EmployeeColumn } from '@benefits/services/tables/employees-table/columns';
import { Paginator } from '@app/classes';
import { Employee } from '@app/models/employee/employee.model';

export class EmployeesIndexTable extends Table {
    links = false;

    constructor(
        protected auth: AuthService,
        public employeeIds: number[]
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.addColumns(new EmployeeColumn());
    }

    setDataSource(): void {
        this.paginator = new Paginator(Employee.param('company', this.auth.company.id).whereIn('id', this.employeeIds));
    }
}
